import React, {useCallback, useEffect, useRef} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'

/**
 * Confirmation modal for deleting a draft or saved shape.
 * Destructive action: user must confirm before delete.
 *
 * @param {{
 *   isOpen: boolean,
 *   toggle: () => void,
 *   type: 'draft' | 'saved',
 *   itemName?: string,
 *   onConfirm: () => void | Promise<void>,
 * }} props
 */
function DeleteShapeConfirmModal({isOpen, toggle, type, itemName, onConfirm}) {
    const cancelBtnRef = useRef(null)

    useEffect(() => {
        if (isOpen && cancelBtnRef.current) {
            cancelBtnRef.current.focus()
        }
    }, [isOpen])

    const handleConfirm = useCallback(async () => {
        await onConfirm()
        toggle()
    }, [onConfirm, toggle])

    const title = type === 'draft' ? 'Delete draft?' : 'Delete shape?'
    const confirmLabel = 'Delete'

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className="CreateCustomShape__DeleteShapeConfirmModal"
            returnFocusAfterClose
        >
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>
                <p className="mb-0">
                    {itemName ? (
                        <>Delete &quot;{itemName}&quot;? This cannot be undone.</>
                    ) : (
                        <>This cannot be undone.</>
                    )}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={toggle} ref={cancelBtnRef} aria-label="Cancel">
                    Cancel
                </Button>
                <Button color="danger" onClick={handleConfirm} aria-label={confirmLabel}>
                    {confirmLabel}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteShapeConfirmModal
